import * as React from 'react';
import './Activity.less';
import { LocalizeContextProps, withLocalize, Translate } from 'react-localize-redux';
import bindAllOfThis from 'src/utils/BindThisHelper';
import StudentActivityDTO from 'src/models/activity/StudentActivityDTO';
import { Game } from "src/constants/Games";
import AudioPlayer from "src/components/common/AudioPlayer";
import AudioTranslations from "src/constants/AudioTranslations";
import { Track } from 'src/providers/TelemetryService';

interface ActivityConclusionProps extends LocalizeContextProps {
    activity: StudentActivityDTO;
    currentGame: Game;
    onNext: () => void;
    onBack: () => void;
}

class ActivityConclusion extends React.Component<ActivityConclusionProps> {
    constructor(props: ActivityConclusionProps) {
        super(props);
        bindAllOfThis(this, ActivityConclusion.prototype);
    }

    componentDidMount(): void {
        document.addEventListener("keydown", this.handleKeyPress, false);
        const { activity, currentGame } = this.props;
        const activityType = activity.isSurvey ? 'Survey' : 'Quiz';
        const activityName = `${currentGame.name}_${currentGame.grade.shortName}${currentGame.planet.name}_${activityType}`;
        Track.Activity(activity.isSurvey ? 'SURVEY' : 'QUIZ', activityName, activity.id, 'CONCLUSION', 1);
    }

    componentWillUnmount() {
        // Remove the event when we change pages
        document.removeEventListener("keydown", this.handleKeyPress, false);
    }

    handleKeyPress(event): void {
        if (event.key === "ArrowRight") {
            this.props.onNext();
        }
        else if (event.key === "ArrowLeft") {
            this.props.onBack();
        }
    }

    render() {
        if (this.props.activity == null || this.props.activity.id < 1) {
            return null;
        }

        let audioTrans = AudioTranslations.FindByKeyAndLanguage(this.props.activity.conclusion.audioKey, this.props.activeLanguage.code);

        return <div className="activity-form">
            <AudioPlayer
                audioURL={audioTrans.url}
                isPlaying={true} />
            <p>{this.props.activity.conclusion.text || ""}</p>
        </div>;
    }
}

export default withLocalize(ActivityConclusion);



// WEBPACK FOOTER //
// ./src/components/student/ActivityConclusion.tsx